import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { style } from './PickerFamilyFriends.style';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { useStore } from 'src/contexts/StoreContext';
import { SecondaryButton } from '@photosi/rn-components/buttons/secondary-button/SecondaryButton';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { brand } from 'src/theme/colors';
import Clipboard from '@react-native-clipboard/clipboard';
import { useEffect, useState } from 'react';
import { EDITOR_BASE_URL } from 'src/app/settings';
import { ROUTE_PATHS } from 'src/routes/_shared/routes.constants';

export const PickerFamilyFriends = observer(() => {
  const {
    i18n,
    project: { createShareTokenFamilyAndFriends, shareTokenFamilyAndFriends },
  } = useStore();
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    if (!shareTokenFamilyAndFriends) {
      createShareTokenFamilyAndFriends().then(res => {
        generateUrl(res);
      });
    } else {
      generateUrl(shareTokenFamilyAndFriends);
    }
  }, []);

  const generateUrl = (token: string) => {
    const urlUploadFamilyAndFriends = `${EDITOR_BASE_URL}/${ROUTE_PATHS.UPLOAD_FAMILY_FRIENDS}?shareToken=${token}`;
    setUrl(urlUploadFamilyAndFriends);
  };
  const copyUrl = async () => {
    Clipboard.setString(`${url}&origin=copy_link`);
  };

  return (
    <View style={style.wrapper}>
      <View style={style.container}>
        <View style={style.illustration}>
          <Illustration name={ILLUSTRATION_NAMES.Upload} />
        </View>
        <View style={style.instructions}>
          <TextLato style={style.stepsTitle}>{i18n.t('modal-picker-family-friends:upload')}</TextLato>
          <View style={style.stepsWrapper}>
            {[1, 2, 3].map(step => {
              return (
                <View style={style.stepContainer} key={`picker-family-friends-step-${step}`}>
                  <View style={style.step}>
                    <TextLato style={style.stepNumber}>{step}</TextLato>
                    <View>
                      <TextLato style={style.stepTitle}>
                        {i18n.t(`modal-picker-family-friends:step-${step}-title`)}
                      </TextLato>
                      <TextLato style={style.stepDescription}>
                        {i18n.t(`modal-picker-family-friends:step-${step}-description`)}
                      </TextLato>
                    </View>
                  </View>
                  {step === 1 && (
                    <View style={style.ctaWrapper}>
                      <SecondaryButton
                        onPress={copyUrl}
                        focusId={`picker-family-friends-step-button-${step}`}
                        focusOrder={0}
                        focusGroup={FocusGroups.LOOKUP_CHOICE}
                        style={{ minHeight: 38, paddingHorizontal: 24 }}
                      >
                        {() => (
                          <View style={style.cta}>
                            <View style={style.ctaIcon}>
                              <Icon name={ICON_NAMES.Copy} color={brand.main.water} />
                            </View>
                            <TextLato style={style.ctaText}>{i18n.t('modal-picker-family-friends:copy-cta')}</TextLato>
                          </View>
                        )}
                      </SecondaryButton>
                    </View>
                  )}
                </View>
              );
            })}
          </View>
        </View>
      </View>
    </View>
  );
});

PickerFamilyFriends.displayName = 'PickerFamilyFriends';